import './shares-style.scss'

import classNames from 'classnames'
import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
} from 'react-share'

import FBIcon from '@/assets/images/fb.svg'
import LinkIcon from '@/assets/images/link.svg'
import TGIcon from '@/assets/images/tg.svg'
import XIcon from '@/assets/images/x.svg'

const Shares = ({ title }) => {
  const [show, setShow] = useState(false)
  const shareUrl =
    typeof window !== 'undefined'
      ? window.location.origin + window.location.pathname
      : ''
  const showCopied = () => {
    setShow(true)
    setTimeout(() => {
      setShow(false)
    }, 1000)
  }
  return (
    <div className="share-container">
      <FacebookShareButton
        url={shareUrl}
        quote={title}
        className="share-button"
      >
        <img src={FBIcon} style={{ width: 50, height: 50 }} />
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl} title={title} className="share-button">
        <img src={XIcon} style={{ width: 50, height: 50 }} />
      </TwitterShareButton>

      <TelegramShareButton
        url={shareUrl}
        title={title}
        className="share-button"
      >
        <img src={TGIcon} style={{ width: 50, height: 50 }} />
      </TelegramShareButton>
      <div className="share-link" style={{ margin: 10 }}>
        <CopyToClipboard text={shareUrl} onCopy={showCopied}>
          <img src={LinkIcon} style={{ width: 50, height: 50 }} />
        </CopyToClipboard>
        <div
          className={classNames({
            'share-copied': true,
            show,
          })}
        >
          <p>Copied</p>
        </div>
      </div>
    </div>
  )
}

export default Shares
